import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core'
import { AlertConfig } from './gb-alert-box.models'

@Component({
  selector: 'gb-alert-box',
  templateUrl: './gb-alert-box.component.html',
  styleUrls: ['./gb-alert-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbAlertBoxComponent {
  @Input() config?: AlertConfig | null

  constructor() {}
}
